import { useStore } from "ra-core";
import type { AgentMode } from "./types";

export function useAgentMode() {
  return useStore<AgentMode>("crm.agentMode", "voice");
}
